/**
 *
 */
interface IItem {
  id: string;
}

const defaultExtractKey = (item: IItem) => item.id;

export default defaultExtractKey;
